// 备注
import React from 'react'
import { connect } from 'dva'
import { component_tool,framework_tool } from '@/tool'
let { WizContainer, WizAvatarUpload, ossFileUtils } = framework_tool
const { WizButton, WizForm, WizComponent, WizInput, WizModal ,Wizmessage } = component_tool

class TrackShiftReport extends WizComponent {

  componentName = 'TrackAddRemark'

  constructor(props) {
    super(props)
    this.state = {

    }
  }

  _componentDidMount() {

  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param {Object} fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    if (fitterValues && fitterValues['imgFileId'] && fitterValues['imgFileId'].length) {
      fitterValues.imgFileId = fitterValues.imgFileId[0].fileId;//icon获取对应上传实体的fileId
    }else {
      fitterValues.imgFileId = null;
    }
    return fitterValues;
  }

  _remarkSubmit = (value) => {
    let { addRemark,onCancelRemark } = this.props
    let fitterValues = this.fitterFieldsValue(value)
    WizModal.confirm({
      title: '注意',
      content: '您将保存此备注，保存后不可更改，是否确认？',
      okText: '是',
      cancelText: '否',
      onOk: () => {
        addRemark(fitterValues)
      },
      onCancel: () => {
        onCancelRemark(fitterValues)
      }
    })
  }

  _returnForm = () => {
    let formColumns = [
      {
        title: '图片备注',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <>
                {getFieldDecorator('imgFileId', {
                  initialValue: (record && record.imgFileId) ? [
                    { fileId: record.imgFileId }
                  ] : [],
                })(
                  <WizAvatarUpload
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    unCropper={true}
                    beforeUpload={(file) => {
                      const isLt20M = file.size / 1024 / 1024 < 20;
                      if (!isLt20M) {
                        Wizmessage.error('图片不得超过20MB!');
                      }
                      return isLt20M;
                    }}
                  />
                )}
              </>
            )
          }
        }
      },
      {
      title: '备注',
      name: 'remark',
      formItem: {
        type: 'custom',
        render: (data, form) => {
          const { getFieldDecorator } = form;
          return (
            <div>
              {
                getFieldDecorator('remark', {
                  rules: [{ required: true, message: '请填写备注信息' }],
                  getValueFromEvent: (e) => {
                    return e.target.value.replace(/\s+/g, '')
                  },
                })(
                  <WizInput.TextArea maxLength={100}
                    placeholder='请填写备注信息,最多100字'
                  />
                )
              }
            </div>
          )
        }
      }
    }]

    const footer = () => {
      return (
        <div className='form-btn'>
          <WizButton type='primary' htmlType='submit'>
            确认
          </WizButton>
        </div>
      )
    }

    const onSubmit = this._remarkSubmit.bind(this)

    let formProps = {
      ref: 'form',
      columns: formColumns,
      onSubmit,
      record: null,
      preview: null,
      footer: footer(),
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 16 }
      }
    }
    return (
      <WizForm {...formProps} />
    )
  }

  render() {
    return (
      this._returnForm()
    )
  }
}

const mapStateToProps = (state, ownProps) => {

  return {}

}

export default connect(mapStateToProps)(TrackShiftReport)



